export default __webpack_public_path__ + "static/media/createProfileSubmit.60b83121.svg";